

import React, { memo } from 'react';
import BooleanValueAddon from '../../components/BooleanValueAddon';








function ChromaKey({
  chromaKey,
  onChangeAddon,
  CHROMA_KEY,
  disabled
}) {
  return (
    <BooleanValueAddon
      options={CHROMA_KEY}
      addonValue={chromaKey}
      onChangeAddon={onChangeAddon('CHROMA_KEY')}
      disabled={disabled}
      title="Green Screen / Chroma Key"
      subtitle="Allow up to 72 hours."
      suffixDoubleDagger />);


}

export default memo(ChromaKey);